<template>
  <header>
    <div class="top">
      <div class="content">
        <div class="logo_box">
          <Logo />
        </div>
        <ul class="top_nav">
          <li>
            <a href="/Society/Index" title="History">學會沿革</a>
          </li>
          <li>
            <a href="/Society/Chapter" title="Articles">學會章程</a>
          </li>
          <li>
            <a href="/Society/Words" title="President">理事長的話</a>
          </li>
          <li>
            <a href="/Society/Supervisory" title="Supervisory">理監事名錄</a>
          </li>
        </ul>
        <div class="member" v-if="!islogin">
          <a href="javascript:;" class="login" @click="openLoginbox">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="14"
              height="14"
              viewBox="0 0 172 172"
              style=" fill:#000000;"
            >
              <g
                fill="none"
                fill-rule="nonzero"
                stroke="none"
                stroke-width="1"
                stroke-linecap="butt"
                stroke-linejoin="miter"
                stroke-miterlimit="10"
                stroke-dasharray
                stroke-dashoffset="0"
                font-family="none"
                font-weight="none"
                font-size="none"
                text-anchor="none"
                style="mix-blend-mode: normal"
              >
                <path d="M0,172v-172h172v172z" fill="none" />
                <g fill="#ffffff">
                  <path
                    d="M86,0c-39.99,0 -73.59069,27.46983 -83.17253,64.5h14.80924c9.159,-29.0465 36.33545,-50.16667 68.36328,-50.16667c39.517,0 71.66667,32.14967 71.66667,71.66667c0,39.517 -32.14967,71.66667 -71.66667,71.66667c-32.02783,0 -59.20428,-21.12017 -68.36328,-50.16667h-14.80924c9.58183,37.03017 43.18253,64.5 83.17253,64.5c47.42183,0 86,-38.57817 86,-86c0,-47.42183 -38.57817,-86 -86,-86zM78.83333,57.33333v21.5h-78.83333v14.33333h78.83333v21.5l40.3125,-28.66667z"
                  />
                </g>
              </g>
            </svg>
            <span>會員登入</span>
          </a>
          <a href="/Home/Registration" class="register">
            <div class="icon icon-member"></div>
            <span>入會申請</span>
          </a>
        </div>
        <div class="login_box" v-if="islogin">
          <a href="/Member/Index" class="memeberCenter">
            <i class="icon icon-member"></i>
            <span class="Id">{{accountemail.split("@")[0]}}，您好。</span>會員專區
          </a>
          <a href="javascript:;" @click="Logout">登出</a>
        </div>
        <div class="menu sp" @click="openMenu" :class="{'xx':mMenuStatus}">
          <div></div>
        </div>
      </div>
    </div>
    <div class="bottom" ref="mMenu">
      <div class="content">
        <ul class="links">
          <li
            class="item"
            v-for="(link,index) in links"
            :key="index"
            v-if="screenWidth > 1200 ? !link.isPhone : true"
          >
            <a
              class="item_link"
              :title="link.en"
              :href="link.url"
              ref="links"
              :data-title="link.root"
            >{{link.title}}</a>
            <div class="openDetail" v-if="link.detail" @click="openDetail($event)" ref="opdetails">+</div>
            <ul v-if="link.detail" class="detail" ref="mlink">
              <li v-for="(item,index) in link.detail" :key="index">
                <a class="detail_link" :href="item.url" :title="link.en">{{item.title}}</a>
              </li>
            </ul>
          </li>
        </ul>
        <div class="m_member">
          <div class="member_centre" v-if="!islogin" @click="openLoginbox">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="16"
              height="16"
              viewBox="0 0 172 172"
              style=" fill:#000000;"
            >
              <g
                fill="none"
                fill-rule="nonzero"
                stroke="none"
                stroke-width="1"
                stroke-linecap="butt"
                stroke-linejoin="miter"
                stroke-miterlimit="10"
                stroke-dasharray
                stroke-dashoffset="0"
                font-family="none"
                font-weight="none"
                font-size="none"
                text-anchor="none"
                style="mix-blend-mode: normal"
              >
                <path d="M0,172v-172h172v172z" fill="none" />
                <g fill="#ffffff">
                  <path
                    d="M86,0c-39.99,0 -73.59069,27.46983 -83.17253,64.5h14.80924c9.159,-29.0465 36.33545,-50.16667 68.36328,-50.16667c39.517,0 71.66667,32.14967 71.66667,71.66667c0,39.517 -32.14967,71.66667 -71.66667,71.66667c-32.02783,0 -59.20428,-21.12017 -68.36328,-50.16667h-14.80924c9.58183,37.03017 43.18253,64.5 83.17253,64.5c47.42183,0 86,-38.57817 86,-86c0,-47.42183 -38.57817,-86 -86,-86zM78.83333,57.33333v21.5h-78.83333v14.33333h78.83333v21.5l40.3125,-28.66667z"
                  />
                </g>
              </g>
            </svg>
            <span>登入</span>
          </div>
          <div class="logout" v-if="!islogin" @click="goRegister">
            <div class="icon icon-member"></div>
            <span>入會申請</span>
          </div>
          <div class="member_centre" v-if="!!islogin" @click="goMember">
            <div class="icon icon-member"></div>
            <span>會員專區</span>
          </div>
          <div class="logout" v-if="!!islogin" @click="Logout">登出</div>
        </div>
        <a class="contactus" href="/Home/ContactUs">
          <div class="icon icon-mail"></div>
        </a>
      </div>
    </div>
    <Loginbox></Loginbox>
  </header>
</template>

<script>
import Logo from "@/components/logo";
import Loginbox from "@/components/loginbox";
import API from "@/service/member";
export default {
  name: "trsheader",
  components: {
    Logo,
    Loginbox
  },
  props: {
    accountemail: {
      type: String
    },
    islogin: {
      type: Boolean
    }
  },
  data() {
    return {
      logo: require("@/assets/logo-h.png"),
      screenWidth: document.documentElement.clientWidth,
      links: [
        {
          url: "/News",
          title: "最新消息",
          en: "Latest News",
          root: "News",
          isPhone: false
        },
        {
          url: "javascript:;",
          title: "學會簡介",
          en: "Society Introduction",
          root: "Society",
          isPhone: true,
          detail: [
            {
              url: "/Society/Index",
              title: "學會沿革"
            },
            {
              url: "/Society/Chapter",
              title: "學會章程"
            },
            {
              url: "/Society/Words",
              title: "理事長的話"
            },
            {
              url: "/Society/Supervisory",
              title: "監理事名錄"
            }
          ]
        },
        {
          url: "javascript:;",
          title: "學術活動",
          en: "Academic",
          root: "Academic",
          isPhone: false,
          detail: [
            {
              url: "/Academic/Activity",
              title: "學術活動"
            },
            {
              url: "/Academic/Silhouette",
              title: "活動花絮"
            },
            {
              url: "/Conference/ActivityProcessList",
              title: "歷屆活動流程"
            }
          ]
        },
        {
          url: "/Event/Index",
          title: "活動報名",
          en: "Event",
          root: "Event",
          isPhone: false
        },
        {
          url: "javascript:;",
          title: "會刊及影音",
          en: "Journals & Videos",
          root: "Conference",
          isPhone: false,
          detail: [
            {
              url: "/Conference/Journals",
              title: "會刊資訊"
            },
            {
              url: "/Conference/DigitalVideos",
              title: "影像數位平台"
            },
            // {
            //   url: "/Conference/RelatedInformation",
            //   title: "會員專屬資訊"
            // }
          ]
        },
        {
          url: "/Conference/RelatedInformation",
          title: "會員專屬資訊",
          en: "Information",
          root: "RelatedInformation",
          isPhone: false,
        },
        {
          url: "javascript:;",
          title: "民眾衛教專區",
          en: "Health Education",
          root: "HealthEducation",
          isPhone: false,
          detail: [
            {
              url: "/HealthEducation",
              title: "衛教資訊"
            },
            {
              url: "/HealthEducation/HealthVideos",
              title: "影像衛教"
            }
          ]
        },
        {
          url: "javascript:;",
          title: "投稿專區",
          en: "Submission",
          root: "Submission",
          isPhone: false,
          detail: [
            {
              url: "/Submission/Index",
              title: "線上投稿"
            },
            {
              url: "/Submission/Admission",
              title: "錄取名單"
            }
          ]
        },
        {
          url: "/Academic/Calendar",
          title: "行事曆",
          en: "Calendar",
          root: "Calendar",
          isPhone: false
        },
        {
          url: "javascript:;",
          title: "醫病共同決策專區",
          en: "MedicalDecision",
          root: "MedicalDecision",
          detail: [
            {
              url: "/MedicalDecision/Index",
              title: "醫病共同決策"
            },
            {
              url: "/MedicalDecision/Feedback",
              title: "醫病決策回饋"
            }
          ]
        },
        {
          url: "/Home/ContactUs",
          title: "聯絡我們",
          en: "Cantact",
          root: "Cantact",
          isPhone: true
        }
      ],
      slideStatus: false,
      mMenuStatus: false,
      LoginStatus: false,
      isGetUrlActive:false
    };
  },
  methods: {
    openSlide() {
      this.slideStatus = true;
    },
    closeSlide() {
      this.slideStatus = false;
    },
    Logout() {
      const vm = this;

      API.getLogout(result => {});
      vm.$swal({
            type: "success",
            text: "登出成功。",
            confirmButtonText: "確定"
        }).then(() => {
            location.href = "/";
        });
    
    },
    openMenu() {
      let el = this.$refs.mMenu;
      if (this.mMenuStatus === true) {
        el.style.top = "-1200%";
        el.style.overflowY = "";
      } else {
        el.style.top = "100%";
        el.style.overflowY = "scroll";
      }
      this.mMenuStatus = this.mMenuStatus ? false : true;
    },
    goUrl(url, hasDetail) {
      // console.log("comming");
      if (!hasDetail) {
        location.href = url;
      } else {
        return false;
      }
    },
    openDetail(e) {
      let thisbtn = e.target;
      let el = e.target.parentNode.childNodes[4];
      let length = el.childNodes.length;
      let nowHeight = el.style.height;
      let all = this.$refs.mlink;
      let allbtn = this.$refs.opdetails;
      all.forEach(item => {
        item.style.height = "";
      });
      allbtn.forEach(item => {
        item.classList.remove("active");
      });
      if (nowHeight == "0px" || nowHeight == "") {
        el.style.height = 46 * length + "px";
        thisbtn.classList.add("active");
      } else {
        el.style.height = 0;
        thisbtn.classList.remove("active");
      }
    },
    openLoginbox() {
      const vm = this;
      let Loginbox = document.getElementById("loginbox");
      // console.log(Loginbox);
      vm.MemberPopup = false;
      let tops = $(document).scrollTop();
      $(document).bind("scroll",function (){$(document).scrollTop(tops); });
      Loginbox.style.display = "flex";
    },
    goRegister() {
      location.href = "/Home/Registration";
    },
    goMember() {
      location.href = "/Member";
    }
  },
  computed: {},
  created() {
    const vm = this;
    if (vm.islogin) {
      localStorage.setItem("veriff", true);
    } else {
      localStorage.removeItem("veriff");
    }
  },
  mounted() {
    const vm = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        vm.screenWidth = window.screenWidth;
      })();
    };
    let url = location.pathname.split("/");
    // console.log(url)
    vm.$refs.links.forEach(item => {
      if(url[2] == 'ActivityProcessList') {
        url[1] = 'Academic'
        if(url[1] == item.dataset.title){
          item.parentNode.classList.add("active");
          item.classList.add("active");
        }
      }
      if(url[2] == item.dataset.title){
        item.parentNode.classList.add("active");
        item.classList.add("active");
        vm.isGetUrlActive = true;
      }
    });
    if(!vm.isGetUrlActive){
      vm.$refs.links.forEach(item => {
        if(url[1] == item.dataset.title){
          item.parentNode.classList.add("active");
          item.classList.add("active");
        }
      })
    }
  },
  watch: {
    $route() {
      let el = this.$refs.mMenu;
      this.mMenuStatus = false;
      el.style.top = "-1200%";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 99;
}
header .content {
  width: 70%;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
header .content .logo_box {
  width: 280px;
}
header .content .top_nav {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1;
  padding: 0 20px;
}
header .content .top_nav li {
  position: relative;
}
header .content .top_nav li + li {
  border-left: 1px solid #888;
}
header .content .top_nav li > a {
  display: block;
  text-decoration: none;
  color: #666;
  padding: 0 20px;
  /* transition: 0.35s; */
  position: relative;
}
header .content .top_nav li:hover a {
  /* color: #fff; */
}
header .content .top_nav li:hover a::after {
  content:attr(title);
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  overflow: hidden;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  font-size: 1rem;
  text-align: center;
  color: #ee8b59;
  transition: 0.35s;
  background-color: #fff;
  width: 100%;
  height: 100%;
}
.top {
  background: #fff;
}
header .content .member {
  overflow: hidden;
  border-radius: 50px;
  flex-wrap: wrap;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
header .content .member .login,
header .content .member .register {
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-decoration: none;
  font-size: 14px;
}
header .content .member .login .icon,
header .content .member .register .icon {
  padding-right: 5px;
}
header .content .member .login svg {
  margin-right: 5px;
}
header .content .member .login {
  background-color: #ee8b59;
  color: #fff;
}
header .content .member .register {
  background-color: #f1f1f1;
  color: #333;
}

.login_box a {
  color: #555;
  text-decoration: none;
  padding: 0 8px;
  transition: 0.35s;
  display: inline-block;
}
.login_box a > i {
  height: 16px;
  display: inline-block;
}
.login_box a + a {
  border-left: 1px solid #ccc;
}
.login_box a:hover {
  color: #ee8b59;
}

.login_box i::before {
  vertical-align: baseline;
}
.bottom {
  background-color: #a59b92;
}
.links {
  width: 95%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.links .item {
  text-align: center;
  font-size: 1.1rem;
  transition: 0.5s;
  flex-grow: 1;
  position: relative;
}
.links .item .item_link {
  cursor: pointer;
  width: 100%;
  padding: 12.5px 10px;
  display: inline-block;
  text-decoration: none;
  color: #fff;
  font-size: 1rem;
  position: relative;
  overflow: hidden;
  vertical-align: middle;
}
.links .item .item_link::after {
  content: attr(title);
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  overflow: hidden;
  top: -100%;
  width: 100%;
  font-size: 1rem;
}
.links .item .item_link.active::after {
  display: flex;
  align-items: center;
  justify-content: center;
  /* background-color: #ee8b59; */
  background-color: #a59b92;
  top: 0;
  width: 99%;
  height: 100%;
}
.links .item .openDetail {
  display: none;
}
.links .detail {
  width: 0;
  position: absolute;
  top: 50%;
  left: 0;
  height: 0;
  transition: height 0.5s ease-out;
  overflow: hidden;
  background-color: #fff;
  z-index: 1;
  overflow: hidden;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}
.links .detail li .detail_link {
  display: block;
  width: 100%;
  padding: 15px 10px;
  text-align: left;
  text-decoration: none;
  color: #333;
  font-size: 1rem;
  font-weight: 500;
  transition: 0.5s;
}
.m_member {
  display: none;
}
.date {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ee8b59;
  width: 19%;
  height: 100%;
  padding: 12px 10px;
  font-size: 1rem;
  color: #fff;
  text-decoration: none;
}
.date div {
  padding: 0 5px;
}
.menu {
  width: 5%;
  padding: 25px 10px;
  cursor: pointer;
}
.menu div {
  width: 15px;
  margin: auto;
  height: 2px;
  background-color: #fff;
  position: relative;
  transition: 0.5s;
}
.menu div::after {
  content: "";
  position: absolute;
  top: -5px;
  width: 20px;
  height: 2px;
  left: 0;
  background-color: #fff;
  transition: 0.5s;
}
.menu div::before {
  content: "";
  position: absolute;
  bottom: -5px;
  width: 20px;
  height: 2px;
  left: 0;
  background-color: #fff;
  transition: 0.5s;
}
.menu.sp {
  background-color: #a59b92;
  width: 40px;
  padding: 20px 10px;
  display: none;
}
.menu.sp div {
  width: 20px;
  height: 3px;
  transition: 0.35s;
}
.menu.sp.xx div {
  background-color: #a59b92;
}
.menu.sp div::after {
  top: -7px;
  width: 20px;
  height: 3px;
  transition: 0.35s;
}
.menu.sp.xx div::after {
  transform: rotate(45deg);
  top: 0;
}
.menu.sp div::before {
  bottom: -7px;
  width: 20px;
  height: 3px;
  transition: 0.35s;
}
.menu.sp.xx div::before {
  bottom: 0;
  transform: rotate(-45deg);
}
.contactus {
  color: #fff;
  text-decoration: none;
  font-size: 1.2rem;
  transition: 0.5s;
}
.contactus:hover {
  color: #ee8b59;
}
@media screen and (max-width: 1600px) {
  .login_box .Id {
    display: none;
  }
}
@media screen and (max-width: 1400px) {
  header .content {
    width: 80%;
  }
}

@media screen and (min-width: 1200px) {
  .links .item:hover .item_link:after {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ee8b59;
    top: 0;
    height: 100%;
    width: 100%;
  }
  .links .item .item_link.active::after {
    width: 100%;
  }
  .links .detail li .detail_link:hover {
    background-color: #ee8b59;
    color:#ffffff;
  }
  .links .item:hover .detail {
    top: 100%;
    width: 250px;
    height: auto;
  }
  .menu:hover div {
    width: 20px;
  }
  .menu:hover div::after {
    width: 15px;
  }
  .menu:hover div::before {
    width: 15px;
  }
  .links .item .item_link.active::before {
    content:"";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 5px;
    background-color: #ee8b59; 
    z-index: 10;
  }
}
@media screen and (max-width: 1199px) {
  header {
    border-bottom: 1px solid #ee8b59;
    z-index: 101;
  }
  header .bottom {
    /* overflow-x: hidden; */
    overflow-x: hidden;
    /* overflow-y: scroll; */
    background: rgba(255, 255, 255, 0.1);
    height: calc(100vh - 70px);
  }
  header .bottom::-webkit-scrollbar {
    height: 0px;
    width: 0px;
    background-color: #5f4e4e;
  }
  header .bottom::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #93204b;
  }
  header .bottom::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    width: 3px;
    border-radius: 10px;
    background-color: #5f4e4e;
  }
  ::-webkit-scrollbar-thumb:window-inactive {
  }
  header .content {
    width: 100%;
    /* overflow-x: hidden;
    overflow-y: scroll; */
  }
  header .bottom .content {
    background-color: #a59b92;
  }
  header .content .member {
    display: none;
  }
  header .content .logo_box {
    width: 200px;
  }
  .top {
    width: 100%;
    padding: 0 2.5%;
    margin: auto;
  }
  header .content .top_nav {
    display: none;
  }
  .links {
    flex-direction: column;
    width: 100%;
  }
  .links .item {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    text-align: left;
    justify-content: space-between;
    border-bottom: 1px solid rgba(0, 0, 0, 0.02);
  }
  .links .item.active {
    background-color: #f2e3d5;
  }
  .links .item .item_link {
    width: calc(100% - 48px);
    padding: 20px 10px;
    /* border-right: 1px solid rgba(0, 0, 0, 0.02); */
  }
  .links .item .item_link.active {
    background-color: #f2e3d5;
  }
  .links .item .item_link.active::after {
    background-color: #f2e3d5;
    color: #665f5a;
  }

  .links .item:hover .item_link:after {
    width: 100%;
  }
  .links .item .openDetail {
    width: 47px;
    display: block;
    padding: 20px;
    cursor: pointer;
    text-align: center;
    color: #fff;
    transition: 0.5s;
  }
  .links .item .openDetail.active {
    transform: rotate(45deg);
  }
  .links .detail {
    position: initial;
    width: 100%;
    padding: 0 20px;
    transition: 0.85s;
    box-shadow: none;
  }
  .bottom {
    width: 100%;
    overflow: hidden;
    transition: 0.85s;
    position: absolute;
    height: auto;
    top: -1200%;
    z-index: -1;
  }
  .bottom .menu {
    display: none;
  }
  .menu.sp {
    display: block;
  }
  .date {
    width: 100%;
    padding: 20px 10px;
  }
  .contactus {
    display: none;
  }
  .login_box {
    display: none;
  }
  .m_member {
    display: flex;
    color: #ffff;
    width: 100%;
  }
  .m_member .login {
    width: 100%;
    text-align: center;
    padding: 15px 0;
  }
  .m_member .member_centre,
  .m_member .logout {
    width: 50%;
    text-align: center;
    padding: 20px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color:#fff;
  }
  .m_member .member_centre > svg {
    margin-right: 8px;
  }
  .m_member .member_centre div:nth-child(1){
    height: 16px;
    margin-right: 8px;
  }
  .m_member .logout > div {
    margin-right: 8px;
  }
  .m_member .member_centre {
    border-right: 1px solid rgba(0, 0, 0, 0.02);
  }
  .m_member .member_centre span,.m_member .logout {
    color:#fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/header.vue